import { ShieldAlert } from "lucide-react";

import { Card, CardContent } from "@/core/components/ui/card";
import useTypedTranslation from "@/core/hooks/use-typed-translation";

/**
 * Fallback « accès refusé » pour les pages réservées par rôle
 * (à passer en `fallback` de `RequireRole` au niveau route).
 */
export function AccessDenied() {
  const { t } = useTypedTranslation();
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-3 py-10 text-center">
          <ShieldAlert className="size-10 text-warning" />
          <h1 className="text-lg font-semibold text-foreground">
            {t("auth.accessDenied.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("auth.accessDenied.description")}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
